//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import animationData from '~/assets/data/lottie/gator.json'
export default {
  data() {
    return {
      defaultOptions: { animationData, loop: false },
    }
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim
      this.anim.play()
      setTimeout(() => {
        this.$emit('finishedAnimation')
      }, 200)
    },
  }
}
